import { MobileUserRole } from '~/types';

export const mobileUserRoleOptions = [
  { value: '', label: 'All' },
  { value: MobileUserRole.Caretaker, label: 'Caretaker' },
  { value: MobileUserRole.HomeHealthCare, label: 'Home HealthCare' },
];

export default {};
